import { render, staticRenderFns } from "./sms-dialog.vue?vue&type=template&id=1722d390"
import script from "./sms-dialog.vue?vue&type=script&lang=js"
export * from "./sms-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports